var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as SavvyResultsUI from "../../../components/SavvyResultsUI/SavvyResultsUI";
import { convertCentsToDollars, shouldOpenInSameWindow, } from "../../../lib/util";
import BundleItem from "./BundleItem";
import { InsuranceType } from "../../../constants";
import { PHASE } from "../../../routeConfig";
import { SellingPointGroups } from "./SellingPoints";
import { clickedOffer } from "../../../lib/Avo";
import { getQuotePriceSecondaryText } from "../../../components/Quote";
import handleResultClick from "../../../utils/handleResultClick";
import { rc2Issuers } from "../../../lib/constants";
import { selectAutoBundleIssuer } from "../../applicant/applicantSlice";
import useAppSelector from "../../../hooks/useAppSelector";
import { useDispatch } from "react-redux";
import useEventPublisher from "../../../hooks/useEventPublisher";
import useImpressionType from "../../../services/savvy/useImpressionType";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
export default function AutoBundleItem(_a) {
    var result = _a.result, impressionId = _a.impressionId, totalMonthlyCostCents = _a.totalMonthlyCostCents, index = _a.index, showBundles = _a.showBundles;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var utmSource = useAppSelector(function (state) { return state.configuration; }).utmSource;
    var dispatch = useDispatch();
    var eventPublisher = useEventPublisher();
    var push = useMemoryHistory().push;
    var impressionType = useImpressionType();
    var auto = result.auto, clickUrl = result.clickUrl;
    var isAd = Boolean(auto.advertiserName);
    var isCurrentPolicy = result.auto.type === "CURRENT_AUTO_POLICY";
    var isRc2 = rc2Issuers.includes(auto.issuerId);
    function handleAdClick(ev) {
        var _a;
        ev.preventDefault();
        clickedOffer(__assign(__assign({}, commonAnalyticsProperties), { impressionType: impressionType, impressionId: impressionId, offerId: result.id, providerName: (_a = (auto.issuerName || auto.advertiserName)) !== null && _a !== void 0 ? _a : "", clickContainsCurrentAutoPolicy: false, clickContainsCurrentHomePolicy: false, affiliate: utmSource, app: "savvy_app", displayedSavingsCents: totalMonthlyCostCents - result.quoteMonthlyCents }));
        eventPublisher.clickOffer(auto, impressionId || "");
        if (clickUrl) {
            var openInSameWindow = shouldOpenInSameWindow();
            var openUrl = "".concat(clickUrl, "?id=").concat(auto.id);
            handleResultClick(openUrl, openInSameWindow);
        }
    }
    function handleQuoteClick(event) {
        event.preventDefault();
        clickedOffer(__assign(__assign({}, commonAnalyticsProperties), { impressionType: impressionType, impressionId: impressionId, offerId: result.id, providerName: auto.issuerName, clickContainsCurrentAutoPolicy: isCurrentPolicy, clickContainsCurrentHomePolicy: false, affiliate: utmSource, app: "savvy_app", displayedSavingsCents: totalMonthlyCostCents - result.quoteMonthlyCents }));
        dispatch(selectAutoBundleIssuer(auto.issuerId));
        push(PHASE.HOME_OFFER_LIST);
    }
    return (React.createElement(SavvyResultsUI.ListItem, { key: result.id },
        React.createElement(BundleItem, { href: clickUrl, title: auto.altText || auto.advertiserName, index: index, result: auto, clickText: isAd || (!result.quoteMonthlyCents && !isCurrentPolicy) ? ("Check Offer") : (React.createElement(SavvyResultsUI.PricePerUnitInDollars, { priceInDollars: convertCentsToDollars(result.quoteMonthlyCents), label: showBundles ? "Auto + Home for" : undefined, secondaryText: getQuotePriceSecondaryText({ isRc2: isRc2, isAd: isAd }) })), onClick: isAd ? handleAdClick : handleQuoteClick, bottomContent: isCurrentPolicy ? (React.createElement("p", { className: "text-xs text-black-100" }, "Selecting this option keeps it in your auto + home offer.")) : auto.sellingPointGroups && auto.sellingPointGroups.length > 0 ? (React.createElement(SellingPointGroups, { groups: auto.sellingPointGroups })) : undefined, insuranceType: InsuranceType.Auto })));
}
